import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppStateService } from '@services/app-state.service';
import type { PuroReservation } from '@models/reservation.interface';

@Component({
  selector: 'app-reservation-list',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './reservation-list.component.html',
  styleUrls: ['./reservation-list.component.scss']
})
export class ReservationListComponent implements OnInit {
  reservations: PuroReservation[] = [];
  loading: boolean = false;

  constructor(
    private router: Router,
    private appState: AppStateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Get reservations from navigation state
    const navigation = this.router.getCurrentNavigation();
    this.reservations = navigation?.extras?.state?.['reservations'] || [];

    // Also try to get from route data/state if navigation state is empty
    if (this.reservations.length === 0) {
      const state = history.state;
      this.reservations = state.reservations || [];
    }
  }

  onSelectReservation(reservation: PuroReservation): void {
    console.log("selectReservation", reservation);
    this.appState.resetAll();
    this.appState.setReservation(reservation);
    this.appState.setCurrentStep(4);
    this.router.navigate(['/send']);
  }

  onBack(): void {
    this.router.navigate(['/search']);
  }

  // Helper methods to extract data from various possible fields
  getGuestName(res: PuroReservation): string {
    return res.fullName || `${res.name || ''} ${res.lastName || ''}`.trim() || 'Nepoznat gost';
  }

  getGuestEmail(res: PuroReservation): string {
    return res.email || '-';
  }

  parseDate(date?: string) {
    return (this.appState.parseDate(date))
  }
}
